module.exports = __webpack_public_path__ + "img/announcements.693f397e.png";